export default __webpack_public_path__ + "static/media/carrot.0040c811.png";